import { Link } from "react-router-dom";
import { Calculator, BarChart3, FileSearch, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/Primitives";
import { IMAGES } from "@/lib/content";

const TOOLS = [
  { icon: Calculator, title: "Compensation Calculator", desc: "Model base, bonus and total comp by role, seniority and market — Monaco, Geneva or Paris.", to: "/tools" },
  { icon: BarChart3, title: "Talent Barometer", desc: "Our quarterly read on hiring velocity, compensation movement and cross-market talent flow.", to: "/tools" },
  { icon: FileSearch, title: "Confidential CV Assessment", desc: "Senior bankers can submit a CV for a discreet, no-obligation market read.", to: "/tools" },
];

export const ToolsPreview = () => {
  return (
    <section className="section-py" data-testid="tools-preview-section">
      <div className="container-bp grid grid-cols-1 items-center gap-14 lg:grid-cols-[0.9fr_1.1fr]">
        <Reveal>
          <div className="relative aspect-square overflow-hidden rounded-[var(--radius-lg)] border border-[color:var(--bp-border)]">
            <img src={IMAGES.marble} alt="Marble and brushed metal texture" className="h-full w-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-[color:var(--bp-bg)] via-transparent to-transparent" />
            <div className="absolute inset-x-6 bottom-6 rounded-[var(--radius-md)] border border-[color:var(--bp-border)] bg-[color:rgba(8,24,48,0.86)] p-5 backdrop-blur-md">
              <p className="text-[11px] uppercase tracking-[0.16em] text-[color:var(--bp-teal)]">Senior RM · Geneva</p>
              <p className="mt-2 font-display text-2xl font-semibold text-[color:var(--bp-cream)]">CHF 220k – 396k <span className="text-base font-normal text-[color:var(--bp-text-muted)]">base + bonus</span></p>
            </div>
          </div>
        </Reveal>

        <div>
          <SectionHeading
            eyebrow="Tools & Intelligence"
            title="Data-driven tools, built by people who priced the market from the inside."
          />
          <div className="mt-9 space-y-3">
            {TOOLS.map((tool, i) => (
              <Reveal key={tool.title} delay={i * 0.08}>
                <Link
                  to={tool.to}
                  data-testid={`tool-preview-${i}`}
                  className="group flex items-center gap-5 rounded-[var(--radius-md)] border border-[color:var(--bp-border)] bg-[color:var(--bp-surface)] p-5 transition-all duration-300 hover:border-[color:var(--bp-teal)]/60 hover:bg-[color:var(--bp-bg-2)]"
                >
                  <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[color:var(--bp-teal)]/40 bg-[color:var(--bp-teal-soft)] text-[color:var(--bp-teal)]">
                    <tool.icon className="h-5 w-5" />
                  </span>
                  <div className="flex-1">
                    <p className="font-display text-lg font-semibold text-[color:var(--bp-cream)]">{tool.title}</p>
                    <p className="mt-1 text-[13.5px] text-[color:var(--bp-text-muted)]">{tool.desc}</p>
                  </div>
                  <ArrowRight className="h-5 w-5 shrink-0 text-[color:var(--bp-text-muted)] transition-all group-hover:translate-x-1 group-hover:text-[color:var(--bp-teal)]" />
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
